// @storybook-skip: internal section of LessonsExploreScreen; covered by its screen story
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import { SortButton } from "./SortButton";
import { TopicChipsRow } from "./TopicChipsRow";
import type {
	ExploreChip,
	LessonSortOption,
	LessonSortType,
	SortOrder,
} from "./types";

type Props = {
	numLessons: number;
	chips: ExploreChip[];
	onChipPress: (type: ExploreChip["type"]) => void;
	searchQuery: string;
	sortOptions: LessonSortOption[];
	sortType: LessonSortType;
	sortOrder: SortOrder;
	onSortPress: () => void;
	hideChips?: boolean;
};

export const LessonsExploreHeader = memo(
	({
		numLessons,
		chips,
		onChipPress,
		searchQuery,
		sortOptions,
		sortType,
		sortOrder,
		onSortPress,
		hideChips = false,
	}: Props) => {
		const theme = useAppTheme();
		const { t } = useTranslation();
		const { isMobile } = useDevice();

		return (
			<Box>
				{hideChips ? null : (
					<Box
						backgroundColor={theme.colors.elevation.level1}
						paddingBottom={16}
					>
						<TopicChipsRow chips={chips} onChipPress={onChipPress} />
					</Box>
				)}
				<Box
					flexDirection="row"
					justifyContent="space-between"
					alignItems="center"
				>
					<CustomListSubheader enableGutters={isMobile}>
						{t("lessons.explore.count", { count: numLessons })}
					</CustomListSubheader>
					{!searchQuery && (
						<SortButton
							sortOptions={sortOptions}
							sortType={sortType}
							sortOrder={sortOrder}
							onPress={onSortPress}
						/>
					)}
				</Box>
			</Box>
		);
	},
);

LessonsExploreHeader.displayName = "LessonsExploreHeader";
